module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"username-description":"Insira apenas letras e números, sem espaços ou símbolos."}}')
  delete Component.options._Ctor
}
